<template>
  <div class="calcFormsForm">
    <div v-if="isloadingData">
      <span>
        <v-progress-circular
          indeterminate
          :size="20"
          color="blue lighten-5"
          class="mr-2"
        ></v-progress-circular
        >Loading..
      </span>
    </div>
    <div v-else-if="inputItem">
      <v-form ref="inputForm" v-model="isFormValid" lazy-validation>
        <div class="inputContainer">
          <v-text-field
            label="Input name"
            v-model="inputItem.InputName"
            :rules="[rules.required]"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div class="inputContainer">
          <v-select
            v-model="inputItem.InputType"
            :items="inputTypes"
            label="Type"
            :readonly="!showFormButtons"
            outlined
            dense
          ></v-select>
        </div>
        <div v-if="inputItem.InputType == 'Lookup'" class="inputContainer">
          <v-text-field
            label="Lookup name"
            v-model="inputItem.LookupName"
            :rules="[rules.required]"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div class="inputContainer">
          <v-text-field
            type="number"
            min="0"
            label="Length"
            v-model="inputItem.Len"
            step="1"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
        <div class="inputContainer">
          <v-text-field
            type="number"
            min="0"
            label="Decimal places"
            v-model="inputItem.Dp"
            :readonly="!showFormButtons"
            step="1"
            dense
            outlined
          ></v-text-field>
        </div>
        <div class="inputContainer">
          <v-text-field
            label="Default value"
            v-model="inputItem.DefaultValue"
            :readonly="!showFormButtons"
            dense
            outlined
          ></v-text-field>
        </div>
      </v-form>
      <div v-if="showFormButtons" class="formFooter">
        <div class="btnContainer">
          <div><v-btn v-if="inputId" outlined color="error" @click="onDelete">Delete</v-btn></div>
          <div>
            <v-btn color="primary" outlined @click="onCancel" class="mr-2"> Cancel </v-btn>
            <v-btn color="primary" depressed @click="onSave"> Save </v-btn>
          </div>
        </div>
      </div>
      <Dialog ref="confirmationDialog" v-model="dialog"></Dialog>
    </div>
    <div v-else>
      <v-alert outlined type="info" dense> No data. </v-alert>
    </div>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'InputForm',
  components: {
    Dialog,
  },
  props: {
    inputId: { type: Number },
    planId: { type: Number },
  },
  data() {
    return {
      isFormValid: false,
      isloadingData: false,
      dialog: false,
      inputItem: null,
      inputTypes: ['Date', 'Number', 'String', 'Lookup'],
      rules: {
        required: (value) => !!value || 'Required.',
      },
    };
  },
  computed: {
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },
  watch: {
    inputId: function () {
      if (this.inputId) this.getInput();
      else this.createNewInput();
    },
  },
  created: function () {
    if (this.inputId) this.getInput();
    else this.createNewInput();
  },
  methods: {
    createNewInput() {
      this.inputItem = {
        InputValue: null,
        InputId: 0,
        PlanId: this.planId,
        GroupId: 0,
        InputName: '',
        InputType: 'String',
        Len: 0,
        Dp: 0,
        DefaultValue: null,
        LookupName: '',
        LookUpItems: null,
      };
    },
    onCancel() {
      if (this.inputId) this.getInput();
      else this.createNewInput();
    },
    onSave() {
      const isFormValid = this.$refs.inputForm.validate();
      if (isFormValid) this.saveData();
    },
    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteInput();
      } catch (err) {
        console.log();
      }
    },
    // click events
    async getInput() {
      if (this.inputId) {
        this.inputItem = null;
        this.isloadingData = true;

        try {
          let response = await this.$api.get(
            '/CalculationInputs/GetCalulationInput?id=' + this.inputId
          );

          if (!response.data) {
            const msg = 'Unable to load input with id ' + this.inputId;
            this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
            throw new Error(msg);
          }

          var data = response.data;
          this.inputItem = data;
          this.isloadingData = false;
        } catch (err) {
          this.isloadingData = false;
          console.error(err);
        }
      }
    },
    async saveData() {
      this.updateInput();
    },
    async updateInput() {
      try {
        let response = await this.$api.post(
          '/CalculationInputs/UpdateCalculationInput',
          this.inputItem
        );

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Input was saved',
        });
        if (this.inputItem.InputId === 0) {
          this.$emit('reloadList', 'update', response.data.Value);
        } else {
          this.$emit('reloadList', 'update');
        }
        this.getInput();
      } catch (err) {
        console.error(err);
      }
    },
    async deleteInput() {
      try {
        await this.$api.delete('/CalculationInputs/DeleteCalculationInput?id=' + this.inputId);

        this.$emit('reloadList', 'delete');
        const message = {
          type: 'success',
          text: 'Delete was successful',
        };
        this.$store.commit('setNotificationMessage', message);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss">
.calcFormsForm {
  position: relative;
  padding-bottom: 36px;
  height: 100%;

  .formFooter {
    bottom: 0;
    width: 100%;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
      justify-content: space-between;
    }
  }

  .plotItemsContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 36px;
  }
}
</style>
